module.exports = __webpack_public_path__ + "img/caret-right-01.52eabdd8.svg";